import TileHero from './TileHero'

export default TileHero
// eslint-disable-next-line import/export
export * from './TileHero'
